// map on gww homepage
// Show popups
// https://www.gww-netz.de/
//
// Author: tobias.wolf@wagnerwagner.de


(function () {
  // functions
  function Marker(element) {
    const mapElement = document.querySelector(`.map *[data-id="${element.id}"]`);
    let height;
    const self = this;

    function init() {
      height = element.offsetHeight;

      element.style.transitionDuration = '0s';
      hide();
      element.style.transitionDuration = null;
    }

    function show() {
      closeOthers(self);
      mapElement.classList.add('is-active');
      element.style.height = `${height}px`;
      element.classList.remove('is-hidden');
      setTimeout(() => {
        element.style.height = null;
      }, TRANSITION_DURATION * 2 + 10);
    }

    function hide() {
      if (!element.classList.contains('is-hidden')) {
        mapElement.classList.remove('is-active');
        height = element.offsetHeight;
        element.style.height = `${height}px`;
        element.offsetHeight;
        element.classList.add('is-hidden');
        element.style.height = null;
      }
    }

    function handleClick() {
      if (element.classList.contains('is-hidden')) {
        show();
      } else {
        hide();
      }
    }

    if (mapElement) {
      mapElement.addEventListener('click', handleClick);

      init();
    }

    this.hide = hide;
  }

  // elements
  const element = document.querySelector('.map');
  const markerElements = document.querySelectorAll('.map-marker');

  // variables
  const markers = [];

  // functions
  function closeOthers(except) {
    for (let i = 0; i < markers.length; i++) {
      const marker = markers[i];
      if (marker !== except) {
        marker.hide();
      }
    }
  }
  // function handleClick(e) {
  //   // don’t hide when click on popup or svg
  //   if (e.target.tagName !== 'polyline' &&
  //       e.target.tagName !== 'path' &&
  //       !e.target.classList.contains('map-marker__inside') &&
  //       !e.target.parentElement.classList.contains('map-marker__inside') &&
  //       !e.target.parentElement.parentElement.classList.contains('map-marker__inside')) {
  //     closeOthers();
  //   }
  // }

  // event listener
  // if (element && markerElements) {
  //   document.addEventListener('click', handleClick);
  // }

  // init instances
  if (element && markerElements) {
    for (let i = 0; i < markerElements.length; i++) {
      markers.push(new Marker(markerElements[i]));
    }
  }
}());
